import {createStore, compose, applyMiddleware} from 'redux';

import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger';

const DEBUG = process.env.NODE_ENV !== 'production';

export default function createZoovetvaruStore(reducer) {
    /* eslint-disable */
    const composeEnhancers =
        typeof window === 'object' && DEBUG &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
    /* eslint-enable */

    const middleware = [];
    if (!DEBUG) {
        middleware.push(thunkMiddleware);
    } else {
        const logger = createLogger({
            collapsed: true,
            duration: true,
        });
        middleware.push(thunkMiddleware, logger);
    }

    const enhancer = composeEnhancers(
        applyMiddleware(...middleware),
    );

    return createStore(reducer, enhancer);
}



// WEBPACK FOOTER //
// ./src/configureStore.js